export class SortManager {
  constructor(algoliaManager, performSearchAndRenderCallback) {
    this.algoliaManager = algoliaManager;
    this.performSearchAndRender = performSearchAndRenderCallback;
    this.sortLinks = document.querySelectorAll(".js-sort-link");
    this.currentActiveSortLink = document.querySelector(
      ".js-sort-link.sort-btn-active",
    );
    this.searchAnnouncer = document.getElementById("search-announcements");

    this.initializeSortUI();
    this.initEventListeners();
  }

  initializeSortUI() {
    if (this.currentActiveSortLink) {
      const initialIndicator = this.currentActiveSortLink.querySelector(
        ".sort-direction-indicator",
      );

      if (initialIndicator) {
        initialIndicator.style.display = "inline-block";
        initialIndicator.style.opacity = 1;
        if (this.currentActiveSortLink.dataset.currentDir === "asc") {
          initialIndicator.classList.add("rotate-180");
        } else {
          initialIndicator.classList.remove("rotate-180");
        }
      }
    }
  }

  initEventListeners() {
    this.sortLinks.forEach((link) => {
      link.addEventListener("click", (e) => this.handleSortClick(e, link));
    });
  }

  async handleSortClick(e, link) {
    e.preventDefault();

    const baseIndex = link.dataset.baseIndex;
    let newDir = link.dataset.currentDir;

    if (link === this.currentActiveSortLink) {
      newDir = newDir === "asc" ? "desc" : "asc";
    }

    const newSortByIndex = `${baseIndex}_${newDir}`;
    this.algoliaManager.setAlgoliaSortByIndex(newSortByIndex);

    link.dataset.currentDir = newDir;

    this.sortLinks.forEach((l) => {
      l.classList.remove("sort-btn-active");
      l.classList.add("sort-btn-inactive");
      l.setAttribute("aria-sort", "none");
      const indicator = l.querySelector(".sort-direction-indicator");
      if (indicator) {
        indicator.style.opacity = 0;
        indicator.classList.remove("rotate-180");
      }
    });

    link.classList.add("sort-btn-active");
    link.classList.remove("sort-btn-inactive");

    link.setAttribute(
      "aria-sort",
      newDir === "asc" ? "ascending" : "descending",
    );

    const activeIndicator = link.querySelector(".sort-direction-indicator");
    if (activeIndicator) {
      activeIndicator.style.opacity = 1;
      if (newDir === "asc") {
        activeIndicator.classList.add("rotate-180");
      } else {
        activeIndicator.classList.remove("rotate-180");
      }
    }

    this.currentActiveSortLink = link;

    await this.performSearchAndRender(
      this.algoliaManager.currentQuery,
      0,
      false,
    );

    if (this.searchAnnouncer) {
      const sortName = link.textContent.trim();
      this.searchAnnouncer.textContent = `Sorted ${sortName}, ${newDir === "asc" ? "ascending" : "descending"}`;
    }
  }
}
